import Lightbox, { ILightBoxProps } from 'react-image-lightbox'
import { css, styled } from 'styled-components'

const LightboxWithClassName = (
  props: ILightBoxProps & { className?: string }
) => {
  const propsWithClassName = {
    ...props,
    wrapperClassName: props.className,
  }
  return <Lightbox {...propsWithClassName} />
}

export const StyledLightbox = styled(LightboxWithClassName)`
  .ril-close {
    margin-left: 40px;
  }
  /* stylelint-disable-next-line selector-class-pattern */
  .ril__toolbar {
    background: none;
  }
  /* stylelint-disable-next-line selector-class-pattern */
  .ril__toolbarItem {
    background: rgb(0 0 0 / 50%);
  }
`

export const CarouselWrapper = styled.div<{ $activeThumbnail: number }>`
  ${({ $activeThumbnail, theme }) => css`
    --activeThumbnail${$activeThumbnail}BorderColor: ${theme.colours.primary.black};
  `}
`
